import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c41b664&scoped=true&lang=html"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./index.scss?vue&type=style&index=0&id=2c41b664&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41b664",
  null
  
)

export default component.exports